import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/shows";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="关于在线观看与追剧的疑问"
              description="这里整理了使用过程中最常被问到的几个问题。如果没有覆盖到你关心的情况，可以在页面底部找到更多说明。"
            />
            <div className="reveal mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-lightbulb-line text-lg text-accent-600"></i>
                小提示
              </p>
              <p className="mt-2 text-sm leading-7 text-foreground-600">
                观看记录默认保存在本地设备，定期整理追剧清单，可以让推荐更贴近你最近的口味。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className={`reveal overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">
                      {faq.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{faq.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}